import React from "react";
import { Box, Container, Grid, Tab, Tabs, Typography } from "@material-ui/core";
import useStyles from "./styles";
import ProfileTab from "./Tabs/ProfileTab";
import { SettingsTabs } from "./constants";
import settingsActions from "./actions";
import { useSelector } from "react-redux";
import AccountTab from "./Tabs/AccountTab";
import ChangePassword from "./dialog/ChangePassword";
import DeactivateConfirmation from "./dialog/ConfirmationDialog";

const SettingsContainer = () => {
  const { selectedTab } = useSelector((state) => state.settings);
  const { setTab } = settingsActions();
  const classes = useStyles();
  return (
    <Grid container className={classes.profileSection}>
      <Grid item xs={12} className={classes.header}>
        <Container>
          <Box className={classes.headerContainer}>
          <Typography variant="h6" style={{fontSize: '18px', fontWeight: 'bold', fontColor: '#323232', marginBottom:  "18px"}} gutterBottom>
              Profile Settings
            </Typography>
            <Tabs
              size="sm"
              value={selectedTab}
              // indicatorColor="primary"
              textColor="primary"
              onChange={(event, newValue) => {
                setTab(newValue);
              }}
              classes={{
                root: classes.tabRoot,
                indicator: classes.tabIndicator,
              }}
            >
              <Tab
                value={SettingsTabs.PROFILE}
                label="Profile"
                className={classes.startingTab}
                classes={{
                  selected: classes.tabActive,
                }}
              />
              <Tab
                value={SettingsTabs.ACCOUNT}
                label="Account"
                className={classes.endingTab}
                classes={{
                  selected: classes.tabActive,
                }}
              />
            </Tabs>
          </Box>
        </Container>
      </Grid>
      {selectedTab === SettingsTabs.PROFILE && <ProfileTab />}
      {selectedTab === SettingsTabs.ACCOUNT && <AccountTab />}
      <ChangePassword />
      <DeactivateConfirmation />
    </Grid>
  );
};

export default SettingsContainer;
